import type { DiagramModel } from './model';
import type { Geometry, Measure } from './geometry';
import { approxMeasure } from './geometry';
import { layoutFlow } from './layout-flow';
import { layoutSequence, type SequenceLabels } from './layout-sequence';

/**
 * DSkhema — the platform's diagram language (docs/ru/DSKHEMA.md).
 * parse → model → layout → geometry → primitives. Pure TypeScript, no DOM.
 */
export * from './model';
export * from './geometry';
export { parse, looksLikeDskhema, resolveShape, flowDirection, withFlowDirection, type ParseOptions } from './parse';export { formatDiagnostic } from './messages';
export { safeCorrections, applyEdits, applyFixes, fixToEdit, closestWord, type TextFix, type SourceEdit } from './autocorrect';
export { toPrimitives, transformPrimitives } from './primitives';
export { THEME } from './theme';
export type { SequenceLabels } from './layout-sequence';

export const LANG_ID = 'dskhema';
export const LANG_VERSION = 2;

/** Only the current language version is rendered on the canvas (docs/ru/DSKHEMA.md). */
export function isSupportedDiagramVersion(v: unknown): boolean {
  return v === LANG_VERSION;
}

export function layout(model: DiagramModel, measure: Measure = approxMeasure, labels?: SequenceLabels): Geometry {
  return model.kind === 'flow' ? layoutFlow(model, measure) : layoutSequence(model, measure, labels);
}

/** Localized block tags for sequence diagrams. */
export function sequenceLabels(locale: string): SequenceLabels {
  return locale === 'ru' ? { block: { loop: 'цикл', alt: 'если', opt: 'опционально', par: 'параллельно' } } : { block: { loop: 'loop', alt: 'alt', opt: 'opt', par: 'par' } };
}
